import { types } from "../types/types";

export const notifications = (data) => ({
  type: types.getNotifications,
  payload: data,
});

export const importNotifications = (data) => {
  return async (dispatch) => {
    try {
      dispatch(notifications(data));
    } catch (error) {
      console.error(error);
    }
  };
};

export const updateNotifications = (data) => ({
  type: types.setNotifications,
  payload: data,
});

export const importUpdateNotifications = (data) => {
  return async (dispatch) => {
    try {
      dispatch(updateNotifications(data));
    } catch (error) {
      console.error(error);
    }
  };
};
